import React from "react";
import { Tabs, Placeholder } from "rsuite";
import { useNavigate } from "react-router-dom";

function TodayContent() {

  const navigate = useNavigate();

  return (
    <div style={{ width: "100%" }} graph="Today">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span style={{ fontSize: "1rem", fontWeight: "500" }}>
          Patients (4)
        </span>
        <button onClick={() => navigate("/ClinicPatients")} style={{ fontSize: "1rem", fontWeight: "500", color: "#3b3778", background: "none" }}>
          See all
        </button>
      </div>

      <div className="">
        <div style={{ marginTop: "1rem" }}>
          <div className="div-zkRuPchRcg">
            <div className="div-RFYAJcqwie">
              <img
                src="/Images/user3.svg"
                alt=""
                style={{ width: "40px", borderRadius: "50%" }}
              />
              <div className="div-uLgIduIlIX">
                <span className="spn-chywGDplLo">Saranya</span>
                <img src="/Images/patientarrow_view.svg" alt="" />
                <span>Dark Blood</span>
              </div>
            </div>
            <span className="spn-ELLgzXlYBr">Pending</span>
          </div>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <div className="div-zkRuPchRcg">
            <div className="div-RFYAJcqwie">
              <img
                src="/Images/user3.svg"
                alt=""
                style={{ width: "40px", borderRadius: "50%" }}
              />
              <div className="div-uLgIduIlIX">
                <span className="spn-chywGDplLo">Harshini</span>
                <img src="/Images/patientarrow_view.svg" alt="" />
                <span>Dark Blood</span>
              </div>
            </div>
            <span
              className="spn-ELLgzXlYBr"
              style={{
                color: "#168458",
                // background: "#E9F4EC",
                border: "1px solid #168458",
              }}
            >
              Confirmed
            </span>
          </div>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <div className="div-zkRuPchRcg">
            <div className="div-RFYAJcqwie">
              <img
                src="/Images/user3.svg"
                alt=""
                style={{ width: "40px", borderRadius: "50%" }}
              />
              <div className="div-uLgIduIlIX">
                <span className="spn-chywGDplLo">Revanth</span>
                <img src="/Images/patientarrow_view.svg" alt="" />
                <span>Dark Blood</span>
              </div>
            </div>
            <span
              className="spn-ELLgzXlYBr"
              style={{
                color: "#D51A2F",
                // background: "#FFEBEB",
                border: "1px solid #D51A2F",
              }}
            >
              Rejected
            </span>
          </div>
        </div>
      </div>

    </div>
  );
}
function WeekContent() {
  return (
    <div style={{ width: "100%" }} graph="Week">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span style={{ fontSize: "1rem", fontWeight: "500" }}>
          Patients (4)
        </span>
        <span style={{ fontSize: "1rem", fontWeight: "500", color: "#3b3778" }}>
          See all
        </span>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <div className="div-zkRuPchRcg">
          <div className="div-RFYAJcqwie">
            <img
              src="/Images/user3.svg"
              alt=""
              style={{ width: "40px", borderRadius: "50%" }}
            />
            <div className="div-uLgIduIlIX">
              <span className="spn-chywGDplLo">Abhiram</span>
              <img src="/Images/patientarrow_view.svg" alt="" />
              <span>Dark Blood</span>
            </div>
          </div>
          <span className="spn-ELLgzXlYBr">Pending</span>
        </div>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <div className="div-zkRuPchRcg">
          <div className="div-RFYAJcqwie">
            <img
              src="/Images/user3.svg"
              alt=""
              style={{ width: "40px", borderRadius: "50%" }}
            />
            <div className="div-uLgIduIlIX">
              <span className="spn-chywGDplLo">Rohan</span>
              <img src="/Images/patientarrow_view.svg" alt="" />
              <span>Dark Blood</span>
            </div>
          </div>
          <span
            className="spn-ELLgzXlYBr"
            style={{
              color: "#168458",
              // background: "#E9F4EC",
              border: "1px solid #168458",
            }}
          >
            Confirmed
          </span>
        </div>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <div className="div-zkRuPchRcg">
          <div className="div-RFYAJcqwie">
            <img
              src="/Images/user3.svg"
              alt=""
              style={{ width: "40px", borderRadius: "50%" }}
            />
            <div className="div-uLgIduIlIX">
              <span className="spn-chywGDplLo">Lakshmi</span>
              <img src="/Images/patientarrow_view.svg" alt="" />
              <span>Dark Blood</span>
            </div>
          </div>
          <span
            className="spn-ELLgzXlYBr"
            style={{
              color: "#D51A2F",
              // background: "#FFEBEB",
              border: "1px solid #D51A2F",
            }}
          >
            Rejected
          </span>
        </div>
      </div>
    </div>
  );
}

function MonthContent() {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Placeholder.Paragraph graph="Month" style={{ width: "100%" }} />
    </div>
  );
}

function Ratings() {
  return (
    <>
      <div>
        <img src="/Images/star_icon.svg" alt="" style={{ width: "18px" }} />
      </div>
    </>
  );
}

function ReviewContent() {
  return (
    <>
      <div style={{ width: "100%" }} graph="Review">
        <div style={{ overflowY: "scroll", height: "16.5rem" }}>
          <div className="div-DzEhaPeRrU">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.2rem",
                marginBottom: "0.5rem",
              }}
            >
              <Ratings />
              <Ratings />
              <Ratings />
              <Ratings />
              <Ratings />
            </div>

            <div style={{ marginBottom: "0.5rem" }}>
              <h5 className="h5-qXjoQcvbtf">Best Treatment for Dark Blood</h5>

              <p className="p-qXjoQcvbtf">
                The clinic provided exceptional care with advanced treatment
                methods. The doctors were highly knowledgeable, and the staff
                was very supportive throughout the process. Highly recommended!{" "}
              </p>
            </div>

            <span className="spn-qXjoQcvbtf">14 people found this helpful</span>
          </div>

          <div className="div-DzEhaPeRrU">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.2rem",
                marginBottom: "0.5rem",
              }}
            >
              <Ratings />
              <Ratings />
              <Ratings />
              <Ratings />
              <Ratings />
            </div>

            <div style={{ marginBottom: "0.5rem" }}>
              <h5 className="h5-qXjoQcvbtf">Best Treatment for Dark Blood</h5>

              <p className="p-qXjoQcvbtf">
                The clinic provided exceptional care with advanced treatment
                methods. The doctors were highly knowledgeable, and the staff
                was very supportive throughout the process. Highly recommended!{" "}
              </p>
            </div>

            <span className="spn-qXjoQcvbtf">14 people found this helpful</span>
          </div>

          <div className="div-DzEhaPeRrU">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.2rem",
                marginBottom: "0.5rem",
              }}
            >
              <Ratings />
              <Ratings />
              <Ratings />
              <Ratings />
              <Ratings />
            </div>

            <div style={{ marginBottom: "0.5rem" }}>
              <h5 className="h5-qXjoQcvbtf">Best Treatment for Dark Blood</h5>

              <p className="p-qXjoQcvbtf">
                The clinic provided exceptional care with advanced treatment
                methods. The doctors were highly knowledgeable, and the staff
                was very supportive throughout the process. Highly recommended!{" "}
              </p>
            </div>

            <span className="spn-qXjoQcvbtf">14 people found this helpful</span>
          </div>
        </div>
      </div>
    </>
  );
}

function ClinicPatientSlot() {
  return (
    <>
      <style>
        {`.rs-nav-pills .rs-nav-item { width: 100%; }
        .rs-nav-pills {
        width: 100%;
        
        }
      `}
      </style>
      <div className="div-OqimEFwXPES" style={{ width: "100%" }}>
        <Tabs defaultActiveKey="1" appearance="pills" style={{ width: "100%" }}>
          <Tabs.Tab eventKey="1" title="Today">
            <TodayContent />
          </Tabs.Tab>
          <Tabs.Tab eventKey="2" title="Week">
            <WeekContent />
          </Tabs.Tab>
          <Tabs.Tab eventKey="3" title="Month">
            <MonthContent />
          </Tabs.Tab>
          <Tabs.Tab eventKey="4" title="Review">
            <ReviewContent />
          </Tabs.Tab>
        </Tabs>
      </div>
    </>
  );
}

export default ClinicPatientSlot;
